// TODO: Move to `array.js` and remove this file.
// export const uniqueArray = (array) => Array.from(new Set(array))

export const uniqueArray = (array) => {
  const uniqueArray = [];

  // Loop through the input array
  for (let i = 0; i < array.length; i++) {
    // Check if the current item is already in the unique array
    if (
      !uniqueArray.some(
        (item) => JSON.stringify(item) === JSON.stringify(array[i]),
      )
    ) {
      // If the current item is not in the unique array, add it
      uniqueArray.push(array[i]);
    }
  }

  return uniqueArray;
};
